import LandingSlider from "areas/landing/elements/landing-slider"
import { Box } from "components/common"
import { jewlr_t } from "helpers/application"
import { SectionDescription, SectionTitle } from "jewlr/pages/components"

const Accessories = () => (
  <>
    <Box bg="#F1F1F2" pb={2} pl={{ _: 4, tablet: 2 }} pr={2} pt={4}>
      <SectionTitle>Accessories</SectionTitle>
      <SectionDescription>
        {jewlr_t("terms.Personalized")} accessories are the finishing touch.
      </SectionDescription>
    </Box>
    <LandingSlider
      element={{
        slider_type: "native",
        item_width: {
          _: "70vw",
          tablet: 3,
        },
        style: {
          bg: "#F1F1F2",
          mx: { tablet: "-16px" },
          pb: 3,
          pr: {
            tablet: "16px",
          },
        },
        arrow_style: {
          top: "37%",
          xPlacement: 4,
        },
        items: [
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-him/rev01-v1/keychains",
            link: "/keychains",
            type: "image",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Keychains",
            },
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-him/rev01-v1/cufflinks",
            link: "/cufflinks",
            type: "image",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Cufflinks",
            },
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-him/rev01-v1/tiebars",
            link: "/tiebars",
            type: "image",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Tie Bars",
            },
          },
          {
            cta: {
              text: "Shop Now",
            },
            folder: "2020-new-landing-collections/for-him/rev01-v1/moneyclips",
            link: "/moneyclips",
            type: "image",
            style: {
              pl: "16px",
              width: { _: "70vw", tablet: "100%" },
            },
            title: {
              text: "Money Clips",
            },
          },
        ],
      }}
    />
  </>
)

export default Accessories
